import React from 'react';

const ThankYouPage = () => {
  return (
    <div className="text-center min-h-[60vh] flex justify-center items-center flex-col mt-[125px] p-2.5 text-white">
      <h1 className="text-5xl pb-10 text-white max-[700px]:text-[2.7rem] max-[500px]:text-[2.4rem]">
        Thank you for getting in touch with Lasgidi Restaurant!
      </h1>
      <h3 className="text-[2.3rem] pb-2.5 max-[700px]:text-[2.2rem] max-[500px]:text-[1.6rem]">
        Your submission has been received.
      </h3>
      <h4 className="text-[1.9rem] max-[700px]:text-[1.7rem] max-[500px]:text-[1.4rem]">
        You'll be contacted soon.
      </h4>
      <br />
      <a href="/" className="text-[1.6rem] text-brand-orange underline hover:text-[#4e8db7] max-[700px]:text-[1.4rem] max-[500px]:text-[1.2rem]">
        Return to Home
      </a>
    </div>
  );
};

export default ThankYouPage;
